export default {
  nav: {
    lite: 'Lite',
    new: 'Nuevo',
  },
  footer: {
    links: {
      lite: 'Geofleet Lite',
    },
  },
  litePage: {
    seoTitle: 'Geofleet Lite — Software de gestión de entregas sencillo para pequeñas empresas',
    seoDescription:
      'Geofleet Lite es gestión de entregas para un solo hub desde $49 al mes con 3 conductores y 500 pedidos. Lite Plus añade planificación de rutas, asignación automática, WhatsApp y API por $99. Lite Autopilot añade AI Copilot y Autopilot por $179. Ahorra hasta un 20% con facturación anual.',
    breadcrumb: 'Geofleet Lite',

    heroBadge: 'Geofleet Lite',
    heroEyebrow: 'Gestión de entregas sencilla para pequeñas empresas',
    heroTitle: 'Tu hub. Tus conductores.',
    heroTitleHighlight: 'Cada entrega en una sola pantalla.',
    /** Direct answer paragraph — quotable by search and AI answer engines. */
    heroLead:
      'Geofleet Lite es un software de entregas para pequeñas empresas con pocos conductores y un único punto de recogida: una tienda, una cocina, una farmacia o un almacén. Añade pedidos, planifica las rutas del día, sigue a tus conductores en un mapa en vivo y envía a cada cliente un enlace de seguimiento. Sin hojas de cálculo y sin perseguir a nadie por grupos de WhatsApp.',
    ctaPrimary: 'Empieza con Lite',
    ctaSecondary: 'Mira cómo funciona',
    heroFacts: [
      { icon: 'ri-price-tag-3-line', label: 'Planes desde $49/mes' },
      { icon: 'ri-user-line', label: '3 conductores incluidos' },
      { icon: 'ri-file-list-3-line', label: '500 pedidos incluidos' },
    ],
    heroVisualAlt: 'Panel de Geofleet Lite con los pedidos de hoy, el estado de las entregas, un resumen de Copilot y alertas de retraso',
    heroDriverAlt: 'App de conductor de Geofleet Lite con la parada actual, el cobro pendiente y las paradas del día',
    heroTrackAlt: 'Página de seguimiento del cliente con la posición del conductor en vivo y la hora de llegada',
    screenshotOf: 'Pantalla de Geofleet Lite: {{title}}',

    problemKicker: '¿Te suena?',
    problemTitle: 'La mayoría de los pequeños equipos de reparto funcionan a base de grupos de chat y memoria',
    problems: [
      { icon: 'ri-whatsapp-line', title: 'Pedidos dispersos en mil chats', text: 'Los pedidos llegan por teléfono, WhatsApp y tu tienda, y alguien los copia a mano en una hoja de cálculo.' },
      { icon: 'ri-route-line', title: 'Rutas planificadas de memoria', text: 'Los conductores zigzaguean por la ciudad porque nadie tiene tiempo de ordenar 30 paradas a mano.' },
      { icon: 'ri-phone-line', title: 'Llamadas de “¿Dónde está mi pedido?”', text: 'El cliente llama a la tienda, la tienda llama al conductor y todos esperan.' },
      { icon: 'ri-money-dollar-circle-line', title: 'Efectivo que no cuadra', text: 'El pago contra reembolso se liquida al final del día a partir de notas sueltas y memoria.' },
    ],

    setupKicker: 'Empieza hoy mismo',
    setupTitle: 'Cinco pasos rápidos y envía tu primera entrega',
    setupIntro: 'Lite solo te pide lo necesario para gestionar tus entregas. Puedes cambiarlo todo después en Ajustes.',
    setupSteps: [
      { icon: 'ri-store-2-line', title: 'Tu negocio', text: 'Nombre, logo y teléfono de atención, para que tus clientes te reconozcan.' },
      { icon: 'ri-map-pin-2-line', title: 'Punto de recogida', text: 'Tu hub: donde empieza y termina cada ruta.' },
      { icon: 'ri-time-line', title: 'Horario de actividad', text: 'Cuándo reparten tus conductores.' },
      { icon: 'ri-shield-check-line', title: 'Reglas de entrega', text: 'Prueba de entrega, reintentos y números de pedido.' },
      { icon: 'ri-message-3-line', title: 'Mensajes a clientes', text: 'Elige SMS, WhatsApp o email para los enlaces de seguimiento.' },
    ],

    dayKicker: 'Un día con Lite',
    dayTitle: 'Todo lo que hace un negocio de reparto con un solo hub, en una sola pantalla',
    dayItems: [
      {
        icon: 'ri-file-list-3-line',
        title: 'Recibe pedidos',
        text: 'Añade un pedido en segundos con búsqueda de direcciones, franja de entrega e importe contra reembolso, o sube un CSV con todo el día.',
        points: ['Autocompletado de direcciones', 'Búsqueda de clientes habituales', 'Importación CSV'],
      },
      {
        icon: 'ri-route-line',
        title: 'Planifica rutas',
        text: 'Elige los pedidos y conductores del día, pulsa Optimizar y arrastra las paradas para ajustar antes de publicar en los teléfonos de los conductores.',
        points: ['Optimización en un clic desde tu hub', 'Reordena o mueve paradas', 'Publica en la app del conductor'],
      },
      {
        icon: 'ri-map-pin-time-line',
        title: 'Sigue todo en vivo',
        text: 'Ve a cada conductor y cada pedido en un mismo mapa con ETA en vivo, y reasigna o comparte un enlace directamente desde el mapa.',
        points: ['Vistas de conductores y pedidos', 'ETA en vivo por parada', 'Lista de pendientes que requieren atención'],
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Prueba la entrega y cobra el efectivo',
        text: 'Los conductores registran la prueba en la puerta y anotan el efectivo cobrado. Tú ves quién tiene cuánto y lo liquidas con un toque.',
        points: ['Foto, firma o nombre del destinatario', 'Efectivo en manos de cada conductor', 'Liquida el efectivo y descarga informes'],
      },
    ],

    hubKicker: 'Hecho para un solo hub',
    hubTitle: 'Pensado para cómo trabajan de verdad los pequeños negocios de reparto',
    hubPoints: [
      { icon: 'ri-home-4-line', title: 'Un único punto de recogida, configurado una vez', text: 'Cada pedido sale de tu hub, así que nunca tendrás que escribir una dirección de recogida.' },
      { icon: 'ri-user-smile-line', title: 'Tus clientes reciben un enlace de seguimiento', text: 'Con tu logo y tus colores. Tus clientes no tienen que instalar ninguna app.' },
      { icon: 'ri-smartphone-line', title: 'Una app del conductor sin complicaciones', text: 'Parada actual, navegación, llamada y prueba de entrega. Nada más.' },
      { icon: 'ri-bar-chart-2-line', title: 'Las cifras del día de un vistazo', text: 'Entregados, fallidos, a tiempo y lo que necesita tu atención, en cuanto abres Lite.' },
    ],

    industriesTitle: 'Muy popular entre',
    industries: [
      { label: 'Restaurantes y cocinas fantasma', href: '/industries/restaurants' },
      { label: 'Farmacias', href: '/industries/pharmacies' },
      { label: 'Supermercados y dark stores', href: '/industries/grocery' },
      { label: 'Floristerías', href: '/industries/flowers' },
      { label: 'Lavanderías', href: '/industries/laundry' },
      { label: 'Reparto de agua', href: '/industries/water' },
    ],

    compareKicker: '¿Lite o la plataforma completa?',
    compareTitle: 'Empieza con Lite. Crece con Geofleet sin empezar de cero.',
    compareIntro:
      'Lite funciona sobre la misma plataforma Geofleet. Cuando abras un segundo hub o quieras despacho con IA, solo cambias de plan y conservas todos tus pedidos, conductores e historial.',
    compareColFeature: 'Lo que necesitas',
    compareColLite: 'Geofleet Lite',
    compareColPlatform: 'Geofleet Command',
    compareRows: [
      { feature: 'Precio', lite: '$49 Lite · $99 Lite Plus · $179 Lite Autopilot', platform: 'Desde $19 por conductor / mes' },
      { feature: 'Conductores', lite: '3 · 10 · 25 incluidos', platform: 'Mínimo 10 conductores' },
      { feature: 'Pedidos', lite: '500 · 1.000 · 2.000 al mes', platform: '5.000+ según plan y conductores' },
      { feature: 'Hubs', lite: 'Uno', platform: 'Multi-hub y multitramo' },
      { feature: 'Planificación de rutas, seguimiento en vivo, prueba de entrega', lite: 'yes', platform: 'yes' },
      { feature: 'Enlaces de seguimiento para clientes', lite: 'yes', platform: 'yes' },
      { feature: 'Shopify y WooCommerce', lite: 'Desde Lite Plus', platform: 'Desde Professional' },
      { feature: 'Planificación de rutas y asignación automática', lite: 'Desde Lite Plus', platform: 'yes' },
      { feature: 'Pedidos y automatización por WhatsApp', lite: 'Desde Lite Plus', platform: 'yes' },
      { feature: 'API y webhooks', lite: 'Desde Lite Plus', platform: 'yes' },
      { feature: 'AI Copilot y Autopilot', lite: 'Lite Autopilot', platform: 'Desde Professional' },
      { feature: 'Suite completa de agentes de IA', lite: 'no', platform: 'yes' },
      { feature: 'Asignación a transportistas, SLA y AI Command Centre', lite: 'no', platform: 'yes' },
    ],
    compareYes: 'Incluido',
    compareNo: 'No incluido',
    compareCta: 'Comparar todos los planes',

    guidesTitle: 'Guías para equipos con un solo hub',
    guides: [
      { label: 'Presentamos Geofleet Lite', href: '/blog/introducing-geofleet-lite' },
      { label: 'Gestión de entregas desde un solo hub: guía diaria', href: '/blog/single-hub-delivery-management-guide' },
      { label: '¿Gestionas entregas en un grupo de WhatsApp? Cuándo dar el salto', href: '/blog/whatsapp-group-delivery-management-alternative' },
      { label: 'Cómo planificar rutas de entrega para una pequeña empresa', href: '/blog/how-to-plan-delivery-routes-small-business' },
    ],

    faqTitle: 'Preguntas frecuentes sobre Geofleet Lite',
    faqs: [
      {
        question: '¿Qué es Geofleet Lite?',
        answer:
          'Geofleet Lite es una versión sencilla de Geofleet para pequeñas empresas que reparten desde un solo hub. Incluye pedidos, planificación de rutas, seguimiento de conductores en vivo, enlaces de seguimiento para clientes, prueba de entrega y gestión del pago contra reembolso.',
      },
      {
        question: '¿Cuánto cuesta Geofleet Lite?',
        answer: 'Lite cuesta $49 al mes e incluye 3 conductores y 500 pedidos. Lite Plus cuesta $99 e incluye 10 conductores y 1.000 pedidos. Lite Autopilot cuesta $179 e incluye 25 conductores y 2.000 pedidos. La facturación trimestral ahorra un 10% y la anual hasta un 20%. Los tres planes son para un solo hub.',
      },
      {
        question: '¿Geofleet Lite es gratis?',
        answer: 'No. Lite empieza en $49 al mes con 3 conductores y 500 pedidos. Puedes probarlo durante 7 días con hasta 100 pedidos.',
      },
      {
        question: '¿Para quién es Geofleet Lite?',
        answer:
          'Para restaurantes, farmacias, tiendas de alimentación, floristerías, lavanderías, distribuidores de agua y otros negocios locales que envían a sus propios conductores desde una sola tienda, cocina o almacén.',
      },
      {
        question: '¿Mis conductores necesitan una app especial?',
        answer: 'Los conductores usan la app del conductor de Geofleet en su teléfono para ver sus paradas, navegar y registrar la prueba de entrega. Los clientes no necesitan ninguna app: reciben un enlace de seguimiento.',
      },
      {
        question: '¿Qué pasa cuando Lite se me queda pequeño?',
        answer:
          'Lite funciona sobre la misma plataforma que Geofleet. Cuando necesites más conductores, más hubs o agentes de despacho con IA, pasas a un plan de pago de Geofleet y conservas todos tus datos.',
      },
      {
        question: '¿Puedo importar mis pedidos actuales?',
        answer: 'Sí. Añade pedidos uno a uno, sube un CSV o usa Lite Plus para sincronizar Shopify y WooCommerce.',
      },
    ],

    ctaTitle: 'Envía hoy tu primera entrega con Lite',
    ctaText: 'Empieza en $49 al mes con 3 conductores y 500 pedidos. Sube a Lite Plus para rutas, asignación automática y WhatsApp, o a Lite Autopilot para que la IA gestione el despacho.',
    ctaTalk: 'Habla con nosotros',
  },
  home: {
    liteTeaser: {
      heroPill: 'Geofleet Lite para equipos con un solo hub, desde $49/mes',
      badge: 'Nuevo',
      title: '¿Repartes desde una sola tienda o almacén?',
      text: 'Conoce Geofleet Lite: pedidos, rutas, seguimiento en vivo y prueba de entrega en una app sencilla, desde $49 al mes con 3 conductores y 500 pedidos.',
      cta: 'Descubre Geofleet Lite',
    },
  },
};
